(function () {
    'use strict';

    angular.module('swif.interventions')
    .config(route)
    .controller('TaskRecurrentDeleteController', TaskRecurrentDeleteController);

    function resolveData(openstc) {
        'ngInject';
        return openstc.task.resolveData();
    }

    function route ($routeProvider, swifInterventionsConstant) {
        'ngInject';
        $routeProvider.when(swifInterventionsConstant.task.routes.table_view, {
            templateUrl: 'partials/openstc/tasks_table_view.html',
            controller: TasksController,
            reloadOnSearch: false,
            resolve: {
                data: resolveData
            }
        });
        $routeProvider.when(swifInterventionsConstant.task.routes.explorer_view, {
            templateUrl: 'partials/openstc/tasks_explorer_view.html',
            controller: TasksController,
            reloadOnSearch: false,
            resolve: {
                data: resolveData
            }
        });
    }


    function TasksController ($scope, $location, $uibModal, $q, swif, openstc, data, swifAchatsService, AttachmentService) {
        'ngInject';
        console.log('init TasksController');
        $scope.modules = swif.module.modules;
        $scope.data = data;
        $scope.countFilter = openstc.task.getCountFilter();
        $scope.cart = swif.cart;

        $scope.achat = swifAchatsService;

        $scope.tasks = data.tasks;
        $scope.attachmentsAction = swif.action.getActionById('intervention', 'meta', 'attachments');
        
        $scope.preModalTask = function (data) {        
            openstc.task.preModal(data);
            if (data.action.id === 'add') {
                if (
                    $location.path() === openstc.task.routes.explorer_view ||
                    $location.path() === openstc.task.routes.table_view
                ) {
                    data.model.state = 'done';
                }
            }
        };

        $scope.preValidateTask = function (data) {
            var ret = openstc.task.preValidate(data);
            if (data.action.id === 'add' && data.model._task_id) {
                data.action.http.url = '/web/dataset/save';
            }
            if (data.action.id === "done" && data.model._referentiel_items.length > 0) {
                var deferred = [];
                // @TODO - for now, we update all instances, even if not edit...
                // Take a lot of time, maybe for nothing :/
                angular.forEach(data.model._referentiel_items, function(item) {
                    if (item.actions.indexOf("update") === -1 || !item.active) {
                        return;
                    }

                    var state = item.state_map[0];
                    var vals = {
                        description: item.description,
                        state: state === "false" ? false: state
                    }
                    deferred.push(swif.data.save(item._type, item.id, vals));
                });
                return $q.all(deferred).then(function() {
                    return true;
                });
            }
            if (data.action.id === 'details') {
                // Get all attachments
                AttachmentService.addAttachments(data.model)
                // Open details modal
                var modalInstance = $uibModal.open({
                    templateUrl: 'partials/openstc/task_details_modal.html',
                    controller: 'TaskDetailsModalController',
                    size: 'lg',
                    resolve: {
                        modalParams: function () {
                            return data;
                        }
                    }
                });
            }
            return ret;
        };

        $scope.callbackTask = openstc.task.callback;

        $scope.dismissCallback = function(data) {
            if (data.action.hiddenTitle) {
                data.action.title = data.action.hiddenTitle;
            }
        }

        $scope.setCurrentItem = function (item) {
            $scope.tasks.setCurrent(item)
            .then(function () {
                $scope.tasks.updateLocation();
            });
        };
    }

    function TaskRecurrentDeleteController ($scope, swif) {
        $scope.tasks = [$scope.model];

        $scope.$watch('model.recurrence.recurrenceChoice', function (newV, oldV){
            if (newV != oldV) {
                if (newV==='fromThisTask'){
                    let tfilter = {};
                    swif.data.addFilter(tfilter, 'recurrence_id', '=', $scope.model.recurrence_id[0]);
                    swif.data.addFilter(tfilter, 'date_start', '>=', $scope.model.date_start.toString());
                    swif.data.searchRead('task', tfilter)
                        .then(function (data) {
                            $scope.tasks = data.records;
                            $scope.model.ids = _.pluck(data.records, 'id');
                        });
                }
                if (newV==='whole'){
                    let tfilter = {};
                    swif.data.addFilter(tfilter, 'recurrence_id', '=', $scope.model.recurrence_id[0]);
                    swif.data.searchRead('task', tfilter)
                        .then(function (data) {
                            $scope.tasks = data.records;
                            $scope.model.ids = _.pluck(data.records, 'id');
                        });
                }
                if (newV==='onlyThisTask'){
                    let tfilter = {};
                    swif.data.addFilter(tfilter, 'recurrence_id', '=', $scope.model.recurrence_id[0]);
                    swif.data.addFilter(tfilter, 'date_start', '=', $scope.model.date_start.toString());
                    swif.data.searchRead('task', tfilter)
                        .then(function (data) {
                            $scope.tasks = data.records;
                            $scope.model.ids = _.pluck(data.records, 'id');
                        });
                }
            }
        });
    }

})();
